<template>
  <a
    href="/"
    class="navbar__logo col-auto c-pr-4 c-lg:c-pl-0 c-lg:c-pr-5 c-lg:c-self-stretch c-lg:flex c-flex-col c-justify-center"
    aria-label="Main logo"
  >
    <LogoTestSvg
      v-if="false"
      height="60"
      width="152"
      icon-alt="Mixit"
      class="c-xxl:c-mr-4 relative text-light"
    />
    <LogoSvg
      v-else
      height="60"
      width="152"
      icon-alt="Mixit"
      class="c-xxl:c-mr-4 relative text-light"
    />
  </a>
</template>

<script setup>
import LogoSvg from '@/components/svg/LogoSvg.vue'
import LogoTestSvg from '@/components/svg/LogoTestSvg.vue'

const isTest = import.meta.env.VITE_VUE_APP_ENV === 'test'
</script>
